import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import { numberFormatter } from '../../../../utils/number';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import Table from '../../../common/Table';
import Badge from '../../../common/Badge';
import CollapsibleHeader from '../../../layout/CollapsibleHeader';
import DebitNotesTable from './DebitNotesTable';

const DebitNoteIncomeSummary = ({
  debitNoteIncomeSummaryList,
  debitNotePaymentMethodSummaryList,
  totalDebitNoteIncome,
  salesSessionId,
}) => {
  if (!debitNoteIncomeSummaryList || !debitNoteIncomeSummaryList.length) {
    return null;
  }

  return (
    <>
      <hr />

      <CollapsibleHeader
        headerText="Notas de Débito"
        component={DebitNotesTable}
        salesSessionId={salesSessionId}
      />

      <Row>
        <Col>
          <Table
            columns={[
              {
                Header: 'Tipo de Comprobante de Pago',
                accessor: 'voucherType',
                className: 'text-center',
                Cell: (row) => {
                  if (!row.value) {
                    return '-';
                  }
                  if (row.original.contingency) {
                    const text = row.value.replace(/electronica/gi, '');
                    return (
                      <>
                        {text} -{' '}
                        <Badge
                          className="bg-secondary text-white"
                          text="Contingencia"
                        />
                      </>
                    );
                  }
                  return <>{row.value}</>;
                },
              },
              {
                Header: 'Serie',
                accessor: 'documentSeries',
                className: 'text-center',
              },
              {
                Header: 'Cantidad',
                accessor: 'numberOfDebitNotes',
                className: 'text-center',
              },
              {
                Header: 'Total',
                accessor: 'totalAmount',
                Cell: ({ value }) => numberFormatter({ value }),
                Footer: (row) =>
                  `Total: ${numberFormatter({
                    value: row.data.reduce(
                      (accumulated, data) => accumulated + data.totalAmount,
                      0,
                    ),
                  })}`,
                className: 'text-right',
              },
            ]}
            data={debitNoteIncomeSummaryList}
            defaultPageSize={debitNoteIncomeSummaryList.length}
            showPagination={false}
          />
        </Col>
      </Row>

      <br />

      {debitNotePaymentMethodSummaryList.map((paymentMethod) => (
        <ResourceProperty
          key={`${paymentMethod.transactionCode}-${paymentMethod.moneyFlowConcept}`}
          label={`${paymentMethod.moneyFlowConcept}: `}
        >
          {numberFormatter({
            value: paymentMethod.totalAmount,
          })}
        </ResourceProperty>
      ))}

      <ResourceProperty label="Total Notas de Débito: ">
        {numberFormatter({
          value: totalDebitNoteIncome,
        })}
      </ResourceProperty>
    </>
  );
};

DebitNoteIncomeSummary.propTypes = {
  debitNoteIncomeSummaryList: PropTypes.arrayOf(
    PropTypes.shape({
      documentSeries: PropTypes.string,
      voucherType: PropTypes.string,
      contingency: PropTypes.bool,
      numberOfDebitNotes: PropTypes.number,
      totalAmount: PropTypes.number,
    }),
  ).isRequired,

  debitNotePaymentMethodSummaryList: PropTypes.arrayOf(
    PropTypes.shape({
      transactionCode: PropTypes.string,
      moneyFlowConcept: PropTypes.string,
      totalAmount: PropTypes.number,
    }),
  ).isRequired,

  totalDebitNoteIncome: PropTypes.number.isRequired,
  salesSessionId: PropTypes.number.isRequired,
};

export default DebitNoteIncomeSummary;
